// Lar único do vocabulário de id de transação VIRTUAL — linhas fabricadas em código que nunca existem
// na tabela `transactions`. Cada tipo tem um prefixo de id próprio pra UI/repos detectarem e (no caso
// da projetada) decodificarem de volta. Antes o prefixo `projected:` vivia no motor de projeção e o
// `accrual-invoice:` era uma string solta no repositório. Ver ADR-0011.

/** Ocorrência projetada de recorrência (memória) — id carrega `recurringId:date` pra materializar. */
export const PROJECTED_RECURRING_ID_PREFIX = 'projected:';

/** Resumo de fatura no regime de competência (memória, só relatório) — id opaco carregando o invoiceId. */
export const ACCRUAL_INVOICE_ID_PREFIX = 'accrual-invoice:';

export function buildProjectedRecurringTransactionId(recurringId: string, date: string): string {
    return `${PROJECTED_RECURRING_ID_PREFIX}${recurringId}:${date}`;
}

export function parseProjectedRecurringTransactionId(
    id: string,
): { recurringId: string; date: string } | null {
    if (!id.startsWith(PROJECTED_RECURRING_ID_PREFIX)) {
        return null;
    }

    const payload = id.slice(PROJECTED_RECURRING_ID_PREFIX.length);
    const lastSeparator = payload.lastIndexOf(':');
    if (lastSeparator <= 0) {
        return null;
    }

    const recurringId = payload.slice(0, lastSeparator);
    const date = payload.slice(lastSeparator + 1);
    if (!recurringId || !/^\d{4}-\d{2}-\d{2}$/.test(date)) {
        return null;
    }

    return { recurringId, date };
}

/**
 * Id fabricado em código (Ocorrência projetada, resumo de fatura por competência) — nunca
 * existe na tabela `transactions`. Repositório que escreve usa isto pra recusar o id na
 * porta, em vez de deixar o `select` vazio virar um "não encontrada" ambíguo.
 */
export function isVirtualTransactionId(id: string): boolean {
    return id.startsWith(PROJECTED_RECURRING_ID_PREFIX) || id.startsWith(ACCRUAL_INVOICE_ID_PREFIX);
}

export function buildAccrualInvoiceTransactionId(invoiceId: string): string {
    return `${ACCRUAL_INVOICE_ID_PREFIX}${invoiceId}`;
}
